/**
 * Tonen van de facets.
 */
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import Maps from "./Maps";
import setSearchUrl from "../actions/setSearchUrl";
import toggleOverlay from "../actions/toggleOverlay";
import { setQueryValue, showFacetFilters } from "../reducers";
import { queryParams } from "../store/queryParams";

class Facets extends Component {
	constructor(props) {
		super(props);
		this.state = {
			initializeRef: false,
			categorySelected: false,
			subCategorySelected: false,
			hasSubCat: false,
			speechStatus: false,
		};
	}
	generateCategoryUrl(categorySlug, subCategorySlug) {
		// We zetten de URL om naar parameters.
		let searchParameters = new URLSearchParams(
			this.props.state.categoryUrl
		);

		/**
		 * We passen de parameters 'topthema' en 'thema' aan naar de juiste
		 * waarden.
		 */
		if (categorySlug) {
			searchParameters.set("topthema", categorySlug);
		}

		if (subCategorySlug) {
			searchParameters.set("thema", subCategorySlug);
		}

		// We zetten de parameters terug om naar een URL.
		let newCategoryUrl = "?" + new URLSearchParams(searchParameters);

		// We sturen de URL terug.
		return newCategoryUrl;
	}

	render() {
		const {
			activeCategoriesObj,
			activeQuery,
			categories,
			facetFilters,
			queryValue,
			regions,
			subjects,
			totalResults,
		} = this.props.state;

		/**
		 * Query dient eerst opgeslagen te worden.
		 * Anders is er geen value om te versturen bij klik op search button.
		 * Eerst setQueryEvent zodat de input opgeslagen kan worden
		 * en mogelijks ook verstuurd kan worden mocht je op de knop klikken.
		 */
		const handleQueryValue = (e) => {
			this.props.dispatch(setQueryValue(e.currentTarget.value));
		};

		// Trigger om search query te starten na klikken button.
		// Hidden van facefitlers
		//toggle van overlay naar false(grijze background)
		const handleQueryClick = (e) => {
			this.props.dispatch(
				setSearchUrl({
					[queryParams.query]: queryValue,
					[queryParams.page]: "",
				})
			);
			this.props.dispatch(showFacetFilters(false));
			toggleOverlay(false);
		};

		const handleQueryKeyDown = (e) => {
			if (13 === e.keyCode) {
				this.props.dispatch(setQueryValue(e.currentTarget.value));
				this.props.dispatch(
					setSearchUrl({
						[queryParams.query]: e.currentTarget.value,
						[queryParams.page]: "",
					})
				);
				this.props.dispatch(showFacetFilters(false));
				toggleOverlay(false);
			}
		};

		const clearQueryClick = (e) => {
			this.props.dispatch(setQueryValue(e.currentTarget.value));
			this.props.dispatch(
				setSearchUrl({
					[queryParams.query]: "",
					[queryParams.page]: "",
				})
			);
			document.querySelector(".queryValue").value = "";
		};

		const handleCategories = (e) => {
			e.preventDefault();
			let categoryQuery = e.currentTarget.dataset.category;
			// Filteren of de categorie reeds geselecteerd werd.
			if (this.props.state.activeCategories.includes(categoryQuery)) {
				if (categoryQuery.includes("|")) {
					// Togglen dat thema verborgen worden indien je in sidebar op thema klikt en enkel topthema nog zichtbaar is.
					this.props.dispatch(
						setSearchUrl({
							[queryParams.topTheme]: categoryQuery.split("|")[0],
							[queryParams.theme]: "",
							[queryParams.page]: "",
						})
					);
				} else {
					// Togglen dat topthema & thema verborgen worden indien je in sidebar op topthema klikt.
					this.props.dispatch(
						setSearchUrl({
							[queryParams.topTheme]: "",
							[queryParams.theme]: "",
							[queryParams.page]: "",
						})
					);
				}
			} else {
				// Indien er nog geen categorie geselecteerd werd
				if (categoryQuery.includes("|")) {
					let categories = categoryQuery.split("|");
					this.props.dispatch(
						setSearchUrl({
							[queryParams.topTheme]: categories[0],
							[queryParams.theme]: categories[1],
							[queryParams.page]: "",
						})
					);
				} else {
					this.props.dispatch(
						setSearchUrl({
							[queryParams.topTheme]: categoryQuery,
							[queryParams.theme]: "",
							[queryParams.page]: "",
						})
					);
				}
			}
		};

		const handleRegions = (labelName) => {
			/**
			 * Checken of er geen dubbels in de activeRegions state komen
			 */
			let activeRegions = [];
			if (this.props.state.activeRegions.includes(labelName)) {
				/**
				 * Geef alle regio's terug zonder de aangeklikte regio als een checkbox uitgezet wordt
				 */
				activeRegions = this.props.state.activeRegions.filter(
					(activeFilter) => {
						return activeFilter !== labelName;
					}
				);
			} else {
				activeRegions = this.props.state.activeRegions;
				activeRegions.push(labelName);
			}

			if (activeRegions.length > 0) {
				this.props.dispatch(
					setSearchUrl({
						[queryParams.regions]: activeRegions.join(),
						[queryParams.page]: "",
					})
				);
			} else {
				this.props.dispatch(
					setSearchUrl({
						[queryParams.regions]: "",
						[queryParams.page]: "",
					})
				);
			}
		};

		const handleSubjects = (subject) => {
			/**
			 * Checken of er geen dubbels in de activeSubjects state komen
			 */
			let activeSubjects = [];
			if (this.props.state.activeSubjects.includes(subject.slug)) {
				/**
				 * Geef alle regio's terug zonder de aangeklikte regio als een checkbox uitgezet wordt
				 */
				activeSubjects = this.props.state.activeSubjects.filter(
					(activeFilter) => {
						return activeFilter !== subject.slug;
					}
				);
			} else {
				activeSubjects = this.props.state.activeSubjects;
				activeSubjects.push(subject.slug);
			}

			if (activeSubjects.length > 0) {
				this.props.dispatch(
					setSearchUrl({
						[queryParams.subjects]: activeSubjects.join(),
						[queryParams.page]: "",
					})
				);
			} else {
				this.props.dispatch(
					setSearchUrl({
						[queryParams.subjects]: "",
						[queryParams.page]: "",
					})
				);
			}
		};

		const toggleFacetsFilter = () => {
			this.props.dispatch(showFacetFilters(false));
			toggleOverlay(false);
		};

		const focusText = (key) => {
			this["focusRef" + key].current.focus();
		};
		const initializeRef = () => {
			if (categories !== undefined && categories !== null) {
				categories.forEach((category) => {
					this["focusRef" + categories.lastIndexOf(category)] =
						React.createRef();
				});
				this.setState({ initializeRef: true });
			}
		};

		const onBlur = (key, subKey) => {
			if (
				categories[key].label ===
					activeCategoriesObj.activeCategoryLabel &&
				subKey + 1 === categories[key].children.length
			) {
				focusText(key);
			}
		};
		const categoryTabIndex = () => {
			return this.state.hasSubCat && activeCategoriesObj.length !== 0
				? "-1"
				: "0";
		};
		const subCategoryTabIndex = (key) => {
			return categories[key].label ===
				activeCategoriesObj.activeCategoryLabel &&
				this.state.categorySelected &&
				this.state.hasSubCat
				? "0"
				: "-1";
		};
		const speechSubcategoryStatus = (key) => {
			return categories[key].label ===
				activeCategoriesObj.activeCategoryLabel
				? "uitgeklapt"
				: "ingeklapt";
		};

		//initialize function with state to prevent to many renders
		if (!this.state.initializeRef) {
			initializeRef();
		}
		return (
			<>
				<div className="facets__wrapper">
					<div className="facets__header facets__content">
						<h2 className="facets__title">Filter je voordelen</h2>
						<button
							className="facets__action"
							onClick={toggleFacetsFilter}
						>
							<span className="visually-hidden">Sluiten</span>
							<span className="icon icon--x icon-size--l"></span>
						</button>
					</div>
					<div class="facets__content">
						<div className="facets__facet facet facet--query">
							<h3 className="facet__title" id="search_voordelen_query_label">Zoek een voordeel</h3>
							<div
								className="facet__form has-xxs-top-margin"
								id="search_voordelen_query"
							>
								<div
									className="form-row form-row--end"
									data-gtm-id="facetfilter_searchterm"
								>
									<div className="form-item">
										{"" !== activeQuery ? (
											<input
												onChange={(e) => {
													handleQueryValue(e);
												}}
												onKeyDown={handleQueryKeyDown}
												className="form-text form-text--clearable queryValue"
												type="text"
												placeholder="Expo's? Pretparken?"
												aria-labelledby="search_voordelen_query_label"
											/>
										) : (
											<input
												onChange={(e) => {
													handleQueryValue(e);
												}}
												onKeyDown={handleQueryKeyDown}
												className="form-text queryValue"
												type="text"
												placeholder="Expo's? Pretparken?"
												aria-labelledby="search_voordelen_query_label"
											/>
										)}
										{"" !== activeQuery && (
											<button
												className="form-text-clear"
												onClick={clearQueryClick}
											>
												<span className="visually-hidden">
													Zoekveld leegmaken
												</span>
												<span className="icon icon--x icon-size--l"></span>
											</button>
										)}
									</div>
									<div className="form-item form-item--static">
										<button
											type="submit"
											className="button form-button is-style-primary"
											onClick={(e) => {
												handleQueryClick(e);
											}}
										>
											<span className="icon icon--magnifier icon-size--s"></span>
											<span className="visually-hidden">
												Zoeken
											</span>
										</button>
									</div>
								</div>
							</div>
						</div>
						<div className="facets__facet facet facet--category has-xs-top-margin">
							<h3 className="facet__title">Kies een categorie</h3>
							<input type="hidden" name="categorie" value="#" />
							<div
								className="categories has-xxs-top-margin"
								id="search_voordelen_thema"
							>
								{categories &&
									categories.length > 0 &&
									categories.map((category, key) =>
										0 === category.children.length ? (
											<div className={"category"}>
												<div
													className={
														"category__label" +
														(activeCategoriesObj.activeCategory ===
														category.slug
															? " is-selected"
															: "")
													}
												>
													<a
														tabIndex={categoryTabIndex}
														onBlur={() => onBlur(key)}
														href={this.generateCategoryUrl(
															category.slug
														)}
														className="category__label-link"
														id={"thema_" + key}
														data-gtm-id="facetfilter_category"
														data-category={
															category.slug
														}
														onClick={(e) => {
															handleCategories(e);
															this.setState({
																categorySelected: true,
																subCategorySelected: false,
																hasSubCat: false,
															});
														}}
													>
														{category.label}
														<span className="category__meta">
															{category.count}
														</span>
													</a>
												</div>
											</div>
										) : (
											<div
												id={"category_" + key}
												className={
													"category has-subcategories" +
													(activeCategoriesObj.activeCategory ===
													category.slug
														? " is-selected"
														: "")
												}
											>
												<div
													className={
														"category__label" +
														(activeCategoriesObj.activeCategory ===
														category.slug
															? " is-selected"
															: "")
													}
												>
													<a
														onBlur={() => onBlur(key)}
														tabIndex={categoryTabIndex}
														ref={this["focusRef" + key]}
														href={this.generateCategoryUrl(
															category.slug
														)}
														className="category__label-link"
														id={"thema_" + key}
														data-gtm-id="facetfilter_category"
														data-category={
															category.slug
														}
														onClick={(e) => {
															handleCategories(e);
															this.setState({
																categorySelected: true,
																subCategorySelected: false,
																hasSubCat: true,
															});
														}}
													>
														{category.label}

														<span className="category__meta">
															{category.count}
															<span className="text_to_speech resubscription_button_status">
																{speechSubcategoryStatus(
																	key
																)}
															</span>
														</span>
													</a>
													<span
														className={
															"icon" +
															(activeCategoriesObj.activeCategory ===
															category.slug
																? " icon--chevron-up"
																: " icon--chevron-down") +
															" icon-size--s"
														}
													></span>
												</div>
												<ul className="category__items">
													{category.children.map(
														(subcategory, subKey) => (
															<li
																className={
																	"category__item" +
																	(activeCategoriesObj.activeSubcategory ===
																	subcategory.slug
																		? " is-selected"
																		: "")
																}
																onBlur={() =>
																	onBlur(
																		key,
																		subKey
																	)
																}
															>
																<div
																	className={
																		"category__label" +
																		(activeCategoriesObj.activeSubcategory ===
																		subcategory.slug
																			? " is-selected"
																			: "")
																	}
																>
																	<a
																		tabIndex={subCategoryTabIndex(
																			key
																		)}
																		onBlur={() =>
																			onBlur(
																				key,
																				subKey
																			)
																		}
																		href={this.generateCategoryUrl(
																			category.slug,
																			subcategory.slug
																		)}
																		className="category__label-link"
																		id={
																			"thema_" +
																			key +
																			"_" +
																			subKey
																		}
																		data-gtm-id="facetfilter_category"
																		data-category={
																			category.slug +
																			"|" +
																			subcategory.slug
																		}
																		onClick={(
																			e
																		) => {
																			handleCategories(
																				e
																			);
																			this.setState(
																				{
																					categorySelected: true,
																					subCategorySelected: true,
																				}
																			);
																		}}
																	>
																		{
																			subcategory.label
																		}
																		<span className="category__meta">
																			{
																				subcategory.count
																			}
																		</span>
																	</a>
																</div>
															</li>
														)
													)}
												</ul>
											</div>
										)
									)}
							</div>
						</div>
						<div className="facets__facet facet facet--location has-xs-top-margin">
							<h3 className="facet__title">Locatie</h3>
							<Maps />
							<div
								className="facet__form has-xs-top-margin"
								id="search_voordelen_location"
							>
								<fieldset className="form-fieldset">
									<legend className="form-legend">
										Kies een regio
									</legend>
									{regions &&
										regions.length > 0 &&
										regions.map((region, key) => (
											<div
												className="form-item form-option"
												tabIndex={0}
												onKeyDown={(e) => {
													if (e.key === "Enter") {
														handleRegions(region.label);
													}
												}}
											>
												<input
													tabIndex={-1}
													className="form-checkbox has-pastel-lk-blue-accent-color"
													data-gtm-id="facetfilter_regio"
													type="checkbox"
													id={"loc_" + key}
													value={region.label}
													checked={
														this.props.state.activeRegions.includes(
															region.label
														)
															? true
															: false
													}
													onChange={(e) => {
														handleRegions(
															e.currentTarget.value
														);
													}}
												/>
												<label
													tabIndex={-1}
													className="form-option__label"
													for={"loc_" + key}
												>
													{region.label}
													<span className="form-option__label-meta">
														{region.count}
													</span>
												</label>
											</div>
										))}
								</fieldset>
							</div>
						</div>
						<div className="facets__facet facet facet--category has-xs-top-margin">
							<h3 className="facet__title">Past bij deze vakken</h3>
							<fieldset className="form-fieldset facet__form has-xxs-top-margin">
									{subjects &&
										subjects.length > 0 &&
										subjects.map((subject, key) => (
											<div
												className="form-item form-option"
												tabIndex={0}
												onKeyDown={(e) => {
													if (e.key === "Enter") {
														handleSubjects(subject);
													}
												}}
											>
												<input
													tabIndex={-1}
													className="form-checkbox has-pastel-lk-blue-accent-color"
													data-gtm-id="facetfilter_vak"
													type="checkbox"
													id={"vak_" + key}
													value={subject.slug}
													checked={
														this.props.state.activeSubjects.includes(
															subject.slug
														)
															? true
															: false
													}
													onChange={(e) => {
														handleSubjects(
															subject
														);
													}}
												/>
												<label
													tabIndex={-1}
													className="form-option__label"
													for={"vak_" + key}
												>
													{subject.label.replaceAll('&amp;', '&')}
													<span className="form-option__label-meta">
														{subject.count}
													</span>
												</label>
											</div>
										))}
								</fieldset>
						</div>
					</div>
					{facetFilters && (
						<div className="facets__facet facets__submit facets__content facet has-xs-top-margin">
							<button
								className="button is-style-primary"
								onClick={toggleFacetsFilter}
							>
								{totalResults !== "" && (
									<Fragment>
										Toon{" "}
										{1 === totalResults
											? totalResults + " voordeel"
											: totalResults + " voordelen"}
									</Fragment>
								)}
							</button>
						</div>
					)}
				</div>
			</>
		);
	}
}

function mapStateToProps(state) {
	return { state };
}

export default connect(mapStateToProps)(Facets);
